/* global axios */
import Vue from 'vue';

export const isPilotAccount = id => /^(1|638)$/.test(String(id));
let requestSequence = 0;
const versionNumber = record => {
  const value = record?.version?.slice(65);
  return /^\d+$/.test(value || '') ? Number(value) : null;
};
const key = (accountId, id) => `${accountId}:${id}`;
const url = (accountId, id = '') =>
  `/api/v1/accounts/${accountId}/jev_signals${id ? `/${id}` : ''}`;

export default {
  namespaced: true,
  state: { records: {}, requests: {} },
  getters: {
    enabled: (_state, _getters, _rootState, rootGetters) => {
      const id = rootGetters.getCurrentAccountId;
      return (
        isPilotAccount(id) &&
        rootGetters['accounts/getAccount'](id).jev_signals_enabled === true
      );
    },
    enabledForInbox: (_state, getters, _rootState, rootGetters) => inboxId => {
      if (!getters.enabled) return false;
      const account = rootGetters['accounts/getAccount'](
        rootGetters.getCurrentAccountId
      );
      return (account.jev_signals_inboxes || []).includes(Number(inboxId));
    },
    get: (state, _getters, _rootState, rootGetters) => id =>
      state.records[key(rootGetters.getCurrentAccountId, id)],
  },
  mutations: {
    request(state, { accountId, ids, token }) {
      state.requests ||= {};
      ids.forEach(id => {
        state.requests[key(accountId, id)] = token;
      });
    },
    set(state, { accountId, records, token }) {
      records.forEach(record => {
        const recordKey = key(accountId, record.conversation_id);
        const incomingVersion = versionNumber(record);
        const existingVersion = versionNumber(state.records[recordKey]);
        const comparable =
          Number.isFinite(incomingVersion) && Number.isFinite(existingVersion);
        if (comparable && incomingVersion < existingVersion) return;
        if (
          token &&
          state.requests?.[recordKey] !== token &&
          !(comparable && incomingVersion > existingVersion)
        )
          return;
        Vue.set(state.records, recordKey, record);
      });
    },
  },
  actions: {
    async load({ getters, rootGetters, commit }, ids) {
      if (!getters.enabled || !ids.length) return;
      const accountId = rootGetters.getCurrentAccountId;
      requestSequence += 1;
      const token = requestSequence;
      commit('request', { accountId, ids, token });
      const { data } = await axios.get(url(accountId), {
        timeout: 5000,
        params: { conversation_ids: [...new Set(ids)].slice(0, 50) },
      });
      commit('set', { accountId, records: data, token });
    },
    async analyze({ getters, rootGetters, commit }, id) {
      if (!getters.enabled) return;
      const accountId = rootGetters.getCurrentAccountId;
      requestSequence += 1;
      const token = requestSequence;
      commit('request', { accountId, ids: [id], token });
      const { data } = await axios.post(
        `${url(accountId, id)}/analyze`,
        {},
        { timeout: 5000 }
      );
      commit('set', { accountId, records: [data], token });
    },
    async correct(
      { getters, rootGetters, commit },
      { id, correction, version }
    ) {
      if (!getters.enabled) return;
      const accountId = rootGetters.getCurrentAccountId;
      requestSequence += 1;
      const token = requestSequence;
      commit('request', { accountId, ids: [id], token });
      const { data } = await axios.patch(
        url(accountId, id),
        { correction, version },
        { timeout: 5000 }
      );
      commit('set', { accountId, records: [data], token });
    },
  },
};
